import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import CustomBackend from './customBackend';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const namespaces = [
  'contactInfo',
  'creditScore',
  'creditScoreImportance',
  'debtAmount',
  'debtCause',
  'debtGoal',
  'debtTypes',
  'employmentStatus',
  'futureLoanPlans',
  'householdIncome',
  'incomeConsistency',
  'name',
  'paymentStatus',
  'propertyType',
  'state',
  'zipCode',
];

if (process.env.NODE_ENV !== 'test') {
  i18n.use(CustomBackend);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    supportedLngs: ['en', 'es'],
    // English is bundled (see vite.config.ts) so boot makes no locale requests;
    // Spanish and the legal namespaces load through the backend on demand.
    preload: ['en'],
    ...(process.env.NODE_ENV !== 'test'
      ? { resources: { en: __EN_LOCALES__ }, partialBundledLanguages: true }
      : {}),
    ns: ['translation', ...namespaces.map((ns) => `subModules/${ns}`)],
    returnObjects: true,
    debug: false,
    react: {
      useSuspense: true,
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p',
        'h2',
        'h3',
        'ol',
        'ul',
        'li',
        'u',
      ],
    },
    returnNull: false,
  });

export default i18n;
